/* eslint-disable */
import { clone, isEmpty, isNil } from 'ramda';

const isNilEmpty = <T>(v: T) => isNil(v) || isEmpty(v);
const _purge = (o: any) => {
  const src = Object.keys(o);
  for (let i = src.length - 1; i >= 0; i--) {
    const k = src[i];
    if (!isNilEmpty(o[k]) && typeof o[k] === 'object') {
      _purge(o[k]);
    } else if (isNilEmpty(o[k])) {
      Array.isArray(o) ? o.splice(parseInt(k, 10), 1) : delete o[k];
    }
  }

  return o;
};

export const purge = (o: any) => _purge(clone(o));
